<template>
  <el-dialog
    title="Notification Events"
    :visible.sync="isVisible"
    width="70vw"
    top="3vh"
    :close-on-click-modal="false"
    @closed="$emit('destroy')"
  >
    <div v-loading="isLoading">
      <el-alert
        v-if="errorMessage"
        :title="errorMessage"
        type="warning"
        :closable="false"
        class="mb-3"
      />

      <el-empty
        v-else-if="events.length === 0"
        description="No notification events found"
      />

      <el-timeline v-else>
        <el-timeline-item
          v-for="event in events"
          :key="`${event.channel}-${event.id}`"
          :timestamp="formatDate(event.created_at)"
          placement="top"
        >
          <el-card shadow="never">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div>
                <el-tag
                  size="mini"
                  :type="event.channel === 'sms' ? 'warning' : 'primary'"
                  class="mr-2"
                >
                  {{ event.channel === 'sms' ? 'SMS' : 'Email' }}
                </el-tag>
                <strong>{{ event.event_name || 'Notification Event' }}</strong>
              </div>

              <el-tag
                size="mini"
                :type="statusTagType(event.response_status)"
              >
                {{ event.response_status || '-' }}
              </el-tag>
            </div>

            <div class="text-muted mb-2">
              <span>Resource: {{ event.resource || '-' }}</span>
              <span class="pl-3">Resource UUID: {{ event.resource_uuid || '-' }}</span>
            </div>

            <template v-if="formatPayload(event.body)">
              <p class="label mb-1">
                Request Body
              </p>
              <pre class="payload">{{ formatPayload(event.body) }}</pre>
            </template>

            <template v-if="formatPayload(event.response_body)">
              <p class="label mb-1 mt-2">
                Response Body
              </p>
              <pre class="payload">{{ formatPayload(event.response_body) }}</pre>
            </template>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>

    <template #footer>
      <el-button @click="isVisible = false">
        Close
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'NotifcationEventDialog',
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isVisible: true,
      isLoading: false,
      errorMessage: '',
      events: []
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      if (!this.resource || typeof this.resource.read !== 'function') {
        this.errorMessage = 'Invalid resource provided.'
        return
      }

      this.isLoading = true
      this.errorMessage = ''

      try {
        await this.resource.read(builder => {
          builder.include = ['sms', 'emails']
        })

        const sms = Array.isArray(this.resource.sms) ? this.resource.sms : []
        const emails = Array.isArray(this.resource.emails) ? this.resource.emails : []

        this.events = [...sms, ...emails].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        console.table(this.events)
      } catch (e) {
        this.errorMessage = 'Failed to load notification events.'
      } finally {
        this.isLoading = false
      }
    },
    formatDate (value) {
      return value ? this.$moment(value).format('DD/MM/YYYY hh:mm a') : '-'
    },
    statusTagType (status) {
      if (!status) return 'info'
      const code = parseInt(status, 10)
      if (!Number.isNaN(code)) {
        if (code >= 200 && code < 300) return 'success'
        if (code >= 400) return 'danger'
      }
      return 'info'
    },
    formatPayload (value) {
      if (value === null || typeof value === 'undefined' || value === '') {
        return ''
      }

      if (typeof value === 'object') {
        return JSON.stringify(value, null, 2)
      }

      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value)
          if (parsed !== null && typeof parsed === 'object') {
            return JSON.stringify(parsed, null, 2)
          }
        } catch (e) {}

        return value
      }

      return `${value}`
    }
  }
}
</script>

<style scoped>
.label {
  color: #909399;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.payload {
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.5;
  margin: 0;
  max-height: 220px;
  overflow: auto;
  padding: 10px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
